import { Checkbox } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Row from "components/common/Row";
import Column from "components/common/Column";
import Pill from "components/common/Pill";
import { titleCase } from "helpers";

const checkedIcon = <CheckBoxIcon fontSize="small" />;
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

const UmbrellaConceptsList = ({ concept, currentSelected, handleCurrentSelected, isChecked, handleChecked, handleTag, style, loadConcepts }) => {

    return (
        <div
            key={concept.id}
            className={`d-flex align-items-center ${concept.id === currentSelected ? 'bg-light-orange' : ''}`}
            style={{
                transition: 'background-color 0.3s ease',
                ...style,
            }}
        >
            <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                checked={isChecked(concept.id)}
                color="primary"
                onChange={(e) => handleChecked(concept.id, e.target.checked)}
            />
            <span
                onClick={async () => {await loadConcepts(concept.concept_ids); handleCurrentSelected(concept.id)}}
                className="cursor-pointer w-100 d-flex justify-content-between"
            >
                <Row className='w-100'>
                    <Column col={8} className='d-flex align-items-center'>
                        <span style={{
                            "font-size": "0.85rem"
                        }}>
                            {titleCase(concept.umbrella_concept)}
                        </span>
                    </Column>
                    <Column col={4} className='d-flex justify-content-end'>
                        <span className="text-end">
                            {
                                concept.tag_type ? (
                                    <Pill variant='info' className='m-1'>
                                        {concept.tag_type}
                                    </Pill>
                                ) : (
                                    <Pill variant='warning' className='m-1' onClick={() => handleTag('Keep', concept.id)}>
                                        k
                                    </Pill>
                                )
                            }
                            {
                                concept.similarity_score ? (
                                    <Pill variant='dark' className='m-1'>
                                        {concept.similarity_score * 100}%
                                    </Pill>
                                ) : ''
                            }
                            <Pill variant='secondary' className='m-1'>
                                {concept.frequency}
                            </Pill>
                        </span>
                    </Column>
                </Row>
            </span>
        </div>
    );
}

UmbrellaConceptsList.defaultProps = {
    concept: [], 
    currentSelected: '', 
    isChecked: () => false, 
    handleChecked: () => {}, 
    handleTag: () => {},
    style: {}
};

export default UmbrellaConceptsList;